

import { Link, useParams } from "react-router-dom";
// import {isMobile} from '../../helpers'
import "./Web19201152.css";
function Web19201152(props) {
  let { videoIndex } = useParams();
  const { backToImage, westurlund_video, cosmic_video } = props;
  let video = (videoIndex === '1') ? westurlund_video : cosmic_video
  return (
    <div className="container-center-horizontal video">
      <div className="web-1920-117 screen">
        <div className="overlap-group1-20">
          {(videoIndex === '1') ? (<video  loop={false} autoPlay muted={true}  playsInline webkit-playsinline={1}>
            <source src={video} type="video/mp4" />
          </video>) : (<video loop={false} autoPlay muted={true}  playsInline webkit-playsinline={1}>
            {/* controls={isMobile() ? true : false}  placed befoe playsInline webkit-playsinline={1} for controls in video of play/pause*/} 
            <source src={video} type="video/mp4" />
          </video>)}
          <div className="overlap-group-43">
          <div className="rectangle-33-18 border-3px-picton-blue">
            <Link to="/web-1920-155/0">
              <div className="back-to-image-8 lato-medium-white-13px">{backToImage}</div>
            </Link>
          </div>
        </div>
      </div>
    </div>
    </div >
  );
}

export default Web19201152;
